import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { SerializableAWSConfig, setAmplifyConfig } from '../config/aws';
import type { RootState } from './store';

export interface ConfigState {
    config?: SerializableAWSConfig;
}

const initialState: ConfigState = {
    config: undefined
};

export const setConfigThunk = createAsyncThunk<
    SerializableAWSConfig,
    { idToken?: string; accessToken?: string } | undefined
>('config/setConfig', async (token) => setAmplifyConfig(token));

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setConfigThunk.fulfilled, (state, action) => {
            state.config = action.payload;
        });
    }
});

export const selectConfig = (
    state: RootState
): SerializableAWSConfig | undefined => {
    return state.config.config;
};

export default configSlice.reducer;
